import React from 'react';
import { renderHTML } from '@agility/nextjs';
import Link from 'next/link';
import styled from '@emotion/styled';
import { useSession } from 'next-auth/react';
import Box from '@mui/material/Box';
import { KitButton } from '@boystownorg/bi-cms-component-lib';
import { useTheme } from '@mui/material/styles';

const Introduction = ({ module }) => {
  const { fields } = module;
  const { data: session, status } = useSession();
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        ml: 'auto',
        mr: 'auto',
        maxWidth: { sm: '540px', md: '768px', lg: '1180px', xl: '1180px' },
      }}
    >
      <Container>
        {fields.titleImage ? (
          <IntroImage>{fields.titleImage ? <img src={fields.titleImage?.url} alt={fields.title} /> : fields.title}</IntroImage>
        ) : fields.title ? (
          <IntroTitle>{fields.titleImage ? <img src={fields.titleImage?.url} alt={fields.title} /> : fields.title}</IntroTitle>
        ) : (
          ''
        )}
        <IntroText
          className='prose max-w-full mx-auto'
          dangerouslySetInnerHTML={renderHTML(
            session ? (fields.introductionTextwithSession ? fields.introductionTextwithSession : fields.introductionText) : fields.introductionText
          )}
        />
        <ButtonContainer align={fields.buttonAlignment}>
          {fields.showButton === 'true' && (
            <a href={fields.buttonUrl.href} target={fields.buttonUrl.target} rel='noopener noreferrer'>
              <KitButton
                round
                size='lg'
                style={{
                  backgroundColor: theme.palette.primary.light,
                }}
              >
                {fields.buttonUrl.text}
              </KitButton>
            </a>
          )}
        </ButtonContainer>
      </Container>
    </Box>
  );
};

export default Introduction;

const Container = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    padding: '20px 15px 20px 15px',
    margin: '30px 0 40px 0',
  },
  [theme.breakpoints.down('md')]: {
    padding: '15px 5px 15px 5px',
    margin: '15px 10px 20px 10px',
  },
}));

const IntroTitle = styled('div')(({ theme }) => ({
  fontSize: '1.65rem',
  color: theme.palette.primary.main,
  fontWeight: 600,
  alignSelf: 'flex-start',
  maxWidth: '162px',
  margin: '8px 20px 8px 0px',
  float: 'left',
  //shapeOutside: 'polygon(0 0, 25% 25%, 25% 25%, 25% 25%)',
}));

const IntroImage = styled('div')(({ theme }) => ({
  fontSize: '1.65rem',
  color: theme.palette.primary.main,
  fontWeight: 600,
  alignSelf: 'flex-start',
  maxWidth: '300px',
  margin: '13px 20px 8px 0px',
  float: 'left',
  //shapeOutside: 'polygon(0 0, 35% 35%, 35% 35%, 35% 35%)',
}));

const IntroText = styled('div')(({ theme }) => ({
  color: theme.palette.common.black,
  margin: 5,
  '& li': {
    '&::before': {
      backgroundColor: '#000 !important',
    },
  },
}));

const ButtonContainer = styled('div')(({ theme, align }) => ({
  margin: '35px 0 0 0',
  display: 'flex',
  flexDirection: 'column',
  cursor: 'pointer',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    alignItems: align || 'center',
  },
  [theme.breakpoints.down('md')]: {
    alignItems: 'center',
  },
}));
